var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "lander-container"
  }, [_c('sanity-lander-header', _vm._b({}, 'sanity-lander-header', _vm.layout.header, false)), _vm._v(" "), _vm.modules && _vm.modules.length > 0 ? _c('div', {
    staticClass: "lander-content"
  }, _vm._l(_vm.modules, function (module) {
    return _c('Modules', {
      key: module._key,
      staticClass: "module-section",
      attrs: {
        "data": module
      }
    });
  }), 1) : _vm._e(), _vm._v(" "), _c('sanity-lander-footer', _vm._b({
    style: _vm.footerStyle
  }, 'sanity-lander-footer', _vm.layout.footer, false))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };